import { render, staticRenderFns } from "./LegalMap.vue?vue&type=template&id=dc165858&scoped=true&"
import script from "./LegalMap.vue?vue&type=script&lang=js&"
export * from "./LegalMap.vue?vue&type=script&lang=js&"
import style0 from "./LegalMap.vue?vue&type=style&index=0&id=dc165858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc165858",
  null
  
)

export default component.exports